export default __webpack_public_path__ + "static/media/help-settings-wht.bd07de5c.svg";